import React, { useEffect, useState, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeft, Database } from 'lucide-react';
import api from '../utils/api';
import LeadTable from '../components/LeadTable';

export default function DatasetView() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [dataset, setDataset] = useState(null);
  const [datasets, setDatasets] = useState([]);
  const [leads, setLeads] = useState([]);
  const [total, setTotal] = useState(0);
  const [pages, setPages] = useState(1);
  const [filters, setFilters] = useState({ dataset_id: id, page: 1, search: '', status: '', qualification: '', city: '', category: '', source: '', utm_campaign: '' });

  const load = useCallback(async () => {
    try {
      const [dsRes, leadsRes, allDs] = await Promise.all([api.get(`/datasets/${id}`), api.get('/leads', { params: filters }), api.get('/datasets')]);
      setDataset(dsRes.data); setLeads(leadsRes.data.leads); setTotal(leadsRes.data.total); setPages(leadsRes.data.pages); setDatasets(allDs.data);
    } catch (err) { console.error(err); }
  }, [id, filters]);

  useEffect(() => { load(); }, [load]);
  if (!dataset) return <div style={{color:'var(--text-muted)',padding:40}}>Cargando...</div>;

  return (
    <div>
      <button className="btn btn-ghost" onClick={() => navigate('/datasets')} style={{ marginBottom: 16 }}><ArrowLeft size={16} /> Volver a Mis Bases</button>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 24 }}>
        <Database size={24} color="var(--accent)" />
        <div>
          <h1 style={{ fontSize: 24, fontWeight: 800 }}>{dataset.name}</h1>
          <p style={{ fontSize: 13, color: 'var(--text-muted)' }}>{dataset.description}</p>
        </div>
      </div>
      <LeadTable leads={leads} total={total} page={filters.page} pages={pages} filters={filters} setFilters={setFilters} onRefresh={load} showDatasetCol={false} datasets={datasets} />
    </div>
  );
}
